module.exports = __webpack_public_path__ + "img/bg_avatar_male_70.3f9ed420.png";